export default "__VITE_ASSET__DMbbSHQ2__"